// CompanyRoadmap.jsx
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./index.css";

const milestones = [
  {
    year: "2024",
    event: "Platform Launch",
    description: "Started our online journey with innovative learning approach",
    icon: "🚀",
  },
  {
    year: "2024",
    event: "First Success Batch",
    description:
      "56 talented students secured internships in leading companies",
    icon: "🎯",
  },
  {
    year: "2025",
    event: "Tech Evolution",
    description: "Embraced cutting-edge technologies for enhanced learning",
    icon: "⚡",
  },
  {
    year: "2026",
    event: "Product Expansion",
    description: "Launched multiple learning products and expanded our reach",
    icon: "📈",
  },
  {
    year: "Future",
    event: "Global Vision",
    description: "Working towards global educational impact and innovation",
    icon: "🌍",
  },
];

const CompanyRoadmap = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 50,
      easing: "ease-in-out-cubic",
    });
  }, []);

  return (
    <section className="roadmap-section">
      <div className="roadmap-container">
        {/* Header */}
        <div className="roadmap-header" data-aos="fade-down">
          <h2>
            Our <span>Journey</span>
          </h2>
          <p>From foundation to future — every milestone matters</p>
        </div>

        {/* Timeline */}
        <div className="timeline">
          {milestones.map((milestone, index) => (
            <div
              key={index}
              className={`timeline-item ${
                index === activeIndex ? "active" : ""
              }`}
              onClick={() => setActiveIndex(index)}
              data-aos="fade-up"
            >
              <div className="timeline-dot">{milestone.icon}</div>

              <div className="timeline-content">
                <h4>{milestone.year}</h4>
                <h3>{milestone.event}</h3>
                <p>{milestone.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyRoadmap;
